export default {
  openChat() {
    window.zE("webWidget", "show");
    window.zE("webWidget", "open");
  }
};
